import React, { PureComponent } from 'react';

import { getCSRFToken } from 'util/redux';

class CSRFInput extends PureComponent {
  render() {
    return (
      <input type="hidden" name="authenticity_token" value={getCSRFToken()} />
    );
  }
}

export default CSRFInput;
